import { isHardNavigationRoute } from '@core/routes'

// On prod and the shared stand `nextjsOrigin` is our own origin, so only the route split may decide
// there; the origin branch exists for the stands where the tiers sit on different ports.
export const isNextjsDestination = (url: string, nextjsOrigin?: string): boolean => {
    if (isHardNavigationRoute(url)) {
        return true
    }

    if (typeof window === 'undefined' || !nextjsOrigin || nextjsOrigin === window.location.origin) {
        return false
    }

    try {
        return new URL(url, window.location.origin).origin === nextjsOrigin
    } catch {
        return false
    }
}
